import Vue from 'vue';

export const UpperCase = {
  update(el) {
    if (el) {
      el.value = el.value.toUpperCase();
    }
  }
}

Vue.directive('uppercase', UpperCase);